<template>
    <div class="row publicationDiv" ref="pub" v-bind:id="publication.id">
        <div class="col-md-3 col-sm d-flex flex-wrap align-items-center">
            <img :src="publication.img" class="pub-img mx-auto d-block" />
        </div>
        <div class="col-md-9 col-sm" style="">
            <span class="pub_title">{{ publication.title }}</span>

            <span v-if="publication.award && publication.award.length" class="pub-award">
                &nbsp; <i class="fas fa-trophy" style="color: #94771e"></i> {{ publication.award }}
            </span>

            <br /><span class="pub_author">{{ publication.author }}</span> <br />

            <!-- <span :class="['badge', publication.badge]">{{ publication.type }}</span> -->
            <span class="badge badge-venue"> {{ publication.bookShort }}</span>
            <span class="pub_book"
                >{{ publication.book }}. {{ publication.year }}.{{ publication.otherinfo }}</span
            >
            <br />

            <!-- {{ publication.about }} -->
            <a-tooltip v-if="publication.about && publication.about.length" placement="right">
                <template #title>
                    {{ publication.about }}
                </template>
                <span class="pub-icon"><i class="fas fa-info-circle"></i> Brief </span>
            </a-tooltip>

            <span v-if="publication.pdf" class="pub-icon"
                ><a :href="publication.pdf"><i class="fas fa-file-pdf"></i> Preprint</a></span
            >

            <span v-if="publication.demo && publication.demo.length" class="pub-icon"
                ><a :href="publication.demo"><i class="fas fa-hand-pointer"></i> Demo</a></span
            >

            <span v-if="publication.github && publication.github.length" class="pub-icon"
                ><a :href="publication.github"><i class="fab fa-github"></i> Github</a></span
            >

            <span v-if="publication.doi && publication.doi.length" class="pub-icon"
                ><a :href="'https://doi.org/' + publication.doi"
                    ><i class="fas fa-link"></i> DOI</a
                ></span
            >

            <span v-if="publication.slides && publication.slides.length" class="pub-icon"
                ><a :href="publication.slides"
                    ><i class="fas fa-file-powerpoint"></i> Slides</a
                ></span
            >

            <span class="pub_download"></span>
        </div>
    </div>
</template>

<script lang="ts">
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import { ref, onMounted, computed, reactive, toRefs, h, watch } from "vue";

const highlightOwnName = (div: any) => {
    var inputText = $(div).find(".pub_author")[0];
    console.log(inputText);

    var innerHTML = inputText.innerHTML;
    var text = "Aoyu Wu";
    var index = innerHTML.indexOf(text);
    if (index >= 0) {
        innerHTML =
            innerHTML.substring(0, index) +
            "<span class='pub_author_me'>" +
            innerHTML.substring(index, index + text.length) +
            "</span>" +
            innerHTML.substring(index + text.length);
    }
    inputText.innerHTML = innerHTML;
};

export default defineComponent({
    name: "App",
    props: ["publication"],
    components: {},
    setup(props) {
        const store = useStore();

        const state = reactive({
            svgStr: computed(() => store.state.svgStr),
        });
        const pub = ref(null);

        onMounted(() => {
            highlightOwnName(pub.value);
        });

        return {
            ...toRefs(state),
            pub,
        };
    },
    computed: {},
});
</script>

<style rel="stylesheet" lang="scss">
.publicationDiv {
    padding: 30px 0;

    border-bottom: 1px solid black;

    a {
        color: #1d1d1f;
        text-decoration: none;
    }
}

.publicationDiv i.fas {
    vertical-align: middle;
    width: 17px !important;
}

.pub_book {
    vertical-align: middle;
    color: #1d1d1f;
    font-weight: 300;
}

.pub-img {
    max-width: 100%;
}
.pub_title {
    font-size: 16px;
    font-weight: bold;
}

.pub-award {
    font-size: 14px;
    color: #96351e;
}

.pub_author {
    font-size: 15px;
}

.badge-j {
    color: #cf1322;
    background: #fff1f0;
    border: 1px solid #ffa39e;
    padding: 0.25em 0.35em !important;
    // background-color: #f58e85 !important;
}

.badge-c {
    color: #d46b08;
    background: #fff7e6;
    border: 1px solid #ffd591;
    padding: 0.25em 0.35em !important;

    // background-color: #f9ad45 !important;
}

.badge-o {
    color: #096dd9;
    background: #e6f7ff;
    border: 1px solid #91d5ff;
    padding: 0.25em 0.35em !important;

    // background-color: #90c7f5 !important;
}

.badge {
    font-weight: 400;
}

.badge-venue {
    margin-left: 2px;
    margin-right: 2px;
    display: inline-block;
    min-width: 10px;
    padding: 3px 7px;
    font-size: 12px;
    font-weight: 400;
    line-height: 1;
    color: #000000d9;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    background: #fafafa;
    border: 1px solid #d9d9d9;
    padding: 0.25em 0.35em !important;

    border-radius: 0.25rem;
}

.pub-icon {
    color: #333 !important;
    margin-right: 16px;
    font-size: 12px;
}

.pub_author_me {
    /* text-decoration: underline; */
    font-weight: 600;
    border-bottom: 2px solid #96351e;
}

.ant-tooltip-inner {
  color: #263459;
  background-color: #E4EAF2;
  width: 400px;
}

</style>
